export default __webpack_public_path__ + "static/media/(90).df6388e9.jpg";